// components/DeleteInverterButton.js
import React from "react";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor";
import { Icon } from "@iconify/react";

const DeleteInverterButton = ({ id, onDeleted }) => {
    const handleDeleteClick = async () => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This inverter will be deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });
        if (confirm.isConfirmed) {
            const res = await fetchData.delete(`/inverter/delete?id=${id}`);
            if (res.status_code === 200) {
                onDeleted();
                Swal.fire("Deleted!", "Inverter has been deleted.", "success");
            } else {
                Swal.fire("Error", "Failed to delete inverter.", "error");
            }
        }
    };

    return (
        <button
            className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center border-0"
            onClick={handleDeleteClick}
        >
            <Icon icon="mingcute:delete-2-line" />
        </button>
    );
};

export default DeleteInverterButton;
